// extracted by mini-css-extract-plugin
module.exports = {"PrimaryNavLink":"PrimaryNavLink_PrimaryNavLink__KxiBE","linkElement":"PrimaryNavLink_linkElement__2c8lW"};